import type { SecondaryMarketLimitOrderReloadedForm } from 'state/secondaryMarket/limit-order/form/original/original.model';
import { limitOrderFormSelectorFactory } from 'state/secondaryMarket/limit-order/form/shared/selectors';
import { formOriginalSelectorsFactory } from 'state/secondaryMarket/shared/form/original/original.selector';

const selectors = limitOrderFormSelectorFactory<SecondaryMarketLimitOrderReloadedForm>('original');

export const limitOrderOriginalFormSelectors = formOriginalSelectorsFactory('limitOrder', {
  getLimit: selectors.getLimit,
  getSalesMarginAdjustment: selectors.getSalesMarginAdjustment,
});
